import 'scss/solutions/gameSolution.scss'
import 'babel-polyfill'
import { toUrl } from 'js/libs/utils'
import { checkLogin } from 'js/api/user'
import 'js/libs/utils-solutions'
import 'js/libs/utils-login'
import { config } from 'config'
$(function () {
  // $('.banner-apply-btn').click(function () {
  //   // toUrl('/solutions/apply?gameSolution')
  //   toUrl(`${config.CONSOLE}workorder/commit?category=${config.SOCID}&id=gameSolution&title=游戏解决方案 - 解决方案申请`, '_blank')
  // })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/gameSolution.js